import React, { Component } from "react";
import TopImage from "../../Components/Courses/TopImg";
import CourseCard from "../../Components/Courses/CoursesCard";
import Header from "../../Components/MainLayout/Header";
import { connect } from "react-redux";
import Axios from "axios";
import Authorize from "../../../global/Authorize";
import noData from "../../Assets/img/noData.png";
import Skeleton from "react-loading-skeleton";
const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});

class TCourses extends Component {
  state = {
    Course: [],
    loading: true,
    fakeData: [1, 2, 3, 4],
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    document.title = "Online Courses";
    this.fetch({
      school: this.props.user.user.school.id,
      status: true,
      for_class: this.props.user.student_class.id,
      for_section: this.props.user.student_section.id,
      course_cordinator: this.props.user.id,
    });
  }

  fetch = (params = {}) => {
    Axios.get(`/courseapi/course`, {
      params: { ...params },
    })
      .then((res) => {
        this.setState({
          Course: res.data,
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  };
  render() {
    return (
      <Authorize roles={["IS_TEACHER"]} redirect to="/">
        <Header title="Courses" />
        <TopImage />
        <div className="container pt-3">
          <div className="row px-2">
            {this.state.loading
              ? this.state.fakeData?.map((item, index) => {
                  return (
                    <div className="col-6 pb-3 px-2" key={index}>
                      <div className="border rounded-lg p-0 m-0">
                        <Skeleton style={{ lineHeight: 1.5 }} height={120} />
                        <Skeleton width={100} className="ml-1" />
                        <Skeleton width={120} className="ml-1" />
                        <Skeleton width={100} className="ml-1" />
                      </div>
                    </div>
                  );
                })
              : null}
          </div>
          <div className="row px-2">
            {this.state.Course.length !== 0 && this.state.loading === false
              ? this.state.Course?.map((item, index) => (
                  <div className="col-6 pb-3 px-2" key={index}>
                    <CourseCard
                      id={item.id}
                      title={item.course_name}
                      first_name={item.course_cordinator.first_name}
                      last_name={item.course_cordinator.last_name}
                      img={item.course_image}
                      sub={item.subject.subject}
                      whatsapp_number={item.course_cordinator.whatsapp_number}
                      userData={this.props.user.user}
                      student_class={this.props.user.student_class}
                      student_section={this.props.user.student_section}
                    />
                  </div>
                ))
              : null}
          </div>
          {this.state.Course.length === 0 && this.state.loading === false ? (
            <div className="px-5 py-5">
              <img className="w-100 mt-5" src={noData} alt="No Data Found" />
              <p className="text-center th-14 th-bold mt-5">
                No Course to Show!
              </p>
            </div>
          ) : null}
        </div>
      </Authorize>
    );
  }
}
export default connect(mapStateToProps)(TCourses);
